import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";

type Divider = {
  strong: boolean;
} & NectarTheme;

export const VerticalDivider = styled("div")<Divider>`
  ${({ theme, strong }) => css`
    min-height: 14px;
    display: inline-block;
    width: ${strong ? "2px" : "1px"};
    background-color: ${theme.colors.gray300};
    margin: 0 ${theme.spacings.xs};
  `}
`;

type HorizontalDividerProps = {
  noMarginTop?: boolean;
  noMarginBottom?: boolean;
} & Divider;

export const HorizontalDivider = styled("div")<HorizontalDividerProps>`
  width: 100%;
  ${({ noMarginTop }) => (noMarginTop ? "" : "margin-top: 10px;")}
  ${({ noMarginBottom }) => (noMarginBottom ? "" : "margin-bottom: 10px;")}
  background-color: ${({ strong, theme }) => theme.colors[strong ? "gray100" : "gray300"]};
  height: ${({ strong }) => (strong ? "2px" : "1px")};
`;
